export const BITRIX = 'service_1c_external';
